import { getRequest, postRequest } from "NetworkCall";
import { INSTANCE_URL } from "Constants";
import { ATTENDEESNETWORK_TOTAL_MSGSENT } from "AttendeesnetworkMsgsentAction";
import { ATTENDEESNETWORK_TOTAL_SCANS } from "AttendeesnetworkScansAction";
export var ATTENDEESNETWORK_MSGSENT = "ATTENDEESNETWORK_MSGSENT";
export var ATTENDEESNETWORK_PROFVIEW = "ATTENDEESNETWORK_PROFVIEW";
export var ATTENDEESNETWORK_ATTESEAR = "ATTENDEESNETWORK_ATTESEAR";
export var ATTENDEESNETWORK_ATTEFAVO = "ATTENDEESNETWORK_ATTEFAVO";
export var ATTENDEESNETWORK_SCANS = "ATTENDEESNETWORK_SCANS";
export var ATTENDEESNETWORK_POPUATTEN_TABLELIST =
  "ATTENDEESNETWORK_POPUATTEN_TABLELIST";
export var ATTENDEESNETWORK_MSTACTVATTEN_TABLELIST =
  "ATTENDEESNETWORK_MSTACTVATTEN_TABLELIST";
export var ATTENDEESNETWORK_MOSTSEARKEYS_TABLELIST =
  "ATTENDEESNETWORK_MOSTSEARKEYS_TABLELIST";

// Charts
export const ATTENDEESNETWORK_ENGAGEMENT_BARCHART =
  "ATTENDEESNETWORK_ENGAGEMENT_BARCHART";
// mostsearkeyslist
export var ATTENDEESNETWORK_SELECTED_ITEM = "ATTENDEESNETWORK_SELECTED_ITEM";
export var ATTENDEESNETWORK_ITEM_SELECTED = "ATTENDEESNETWORK_ITEM_SELECTED"; // main

export function onAttendeesnetworkMenuSelected(selectedMenu) {
  return (dispatch) => {
    dispatch({ type: ATTENDEESNETWORK_ITEM_SELECTED, payload: selectedMenu });
  };
}

export function dispatchAnalyticsData(data) {
  return (dispatch) => {
    //dispatch({type: SOCIALFEED_TOTAL_POST, payload: {count:data}}); count:data.devices.count
    dispatch({
      type: ATTENDEESNETWORK_TOTAL_MSGSENT,
      payload: { count: data },
    });
    dispatch({ type: ATTENDEESNETWORK_TOTAL_SCANS, payload: { count: data } });
  };
}

// Popular Attendees (Attendees who received the most networking actions from the other app users)
const fetchPopuattenTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=popuattenlist&types=entry&screen=attendees&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Popular Attendees Table data (List) Installs..
        dispatch({
          type: ATTENDEESNETWORK_POPUATTEN_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics Popular Attendees Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Most Active networks (Attendees who made the most networking actions from the other app users)
const fetchMstactvattenTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=mostactiventwrkslist&types=entry&screen=attendees&eventid=${session.eventid}`;
  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for Popular Attendees Table data (List) Installs..
        dispatch({
          type: ATTENDEESNETWORK_MSTACTVATTEN_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics Attendees Most Active networks Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

// Most search keywords (most search keywords related to attendees)
const fetchAttenMostsearkeysTableData = (session, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=mostsearkeyslist`;
  return (dispatch) => {
    postRequest(
      url,
      {
        type: "mostsearkeyslist",
        types: "search",
        screen: "attendees",
        eventid: session.eventid,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        //Prepare data for most search keywords related to attendees Table data (List) ..
        dispatch({
          type: ATTENDEESNETWORK_MOSTSEARKEYS_TABLELIST,
          data: data.resource,
        });
        callback({
          error: 0,
          data: "Analytics most search keywords related to attendees Table data Fetched !",
        });
      },
      (error) => {
        callback({ error: 1, data: error });
      }
    );
  };
};

// Network Engagement (Chart view of how active users has been using the networking feature of the app over the selected date range)
const fetchAttnNetwrkEngaBarChart = (session, daterange, callback) => {
  var url = `${INSTANCE_URL}/api/v2/analytics?type=netwrkFeatureEngmntData`;

  return (dispatch) => {
    postRequest(
      url,
      {
        type: "netwrkFeatureEngmntData",
        eventid: session.eventid,
        fromDate: daterange.from,
        toDate: daterange.to,
      },
      session,
      dispatch,
      (response) => {
        var data = response;

        dispatch({
          type: ATTENDEESNETWORK_ENGAGEMENT_BARCHART,
          payload: { response: data.resource },
        });
        callback({ error: 0, data: "Analytics Network Engagement Fetched !" });
      },
      (error) => {
        callback({ error: 1, data: null });
      }
    );
  };
};

export {
  fetchPopuattenTableData,
  fetchMstactvattenTableData,
  fetchAttenMostsearkeysTableData,
  fetchAttnNetwrkEngaBarChart,
};
